import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { DVFormArray, executeBlueprint, DVFormGroup } from '../dynamic-validator';
import _ from 'lodash';
import { DvTestService } from '../dv-test.service';

interface ItemContext {
  arrayItem: any;
  index: number;
  $implicit: any;
}

@Component({
  selector: 'app-formarray-container',
  templateUrl: './formarray-container.component.html',
  styleUrls: ['./formarray-container.component.css']
})
export class FormarrayContainerComponent implements OnInit {

  @Input() formTemplate: TemplateRef<any>;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() formArray: DVFormArray;
  @Input() formArrayName: string;
  context: {};
  range = _.range;
  constructor(
  ) {
  }

  ngOnInit() {
    this.formArray.init();
  }

  get header() {
    if (this.formArrayName) {
      return _.startCase(this.formArrayName);
    } else {
      return null;
    }
  }

  addItem() {
    // const blueprint = this.formArray.getBlueprint();
    // const group = executeBlueprint(blueprint);
    // console.log(group);
    // const index = this.formArray.length;
    // this.formArray.setControl(index, group);
    // console.log((this.formArray.root as DVFormGroup).get('ExperienceDays.0.Activities'))
    // this.formArray.push(group);
    this.formArray.addChildrenFromBlueprint();
  }

  removeItem(index) {
    this.formArray.removeAt(index);
  }

  getContext(index): ItemContext {
    // console.log(this.formArray.at(index));
    return {
      $implicit: {index: -1 , arrayItem: null},
      arrayItem: this.formArray.controls[index],
      index
    };
  }

}
